import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import "../assets/styles/SareesPage.css"; // Reuse the same styles
import { BaseUrl } from "../config/api";
import defaultImage from "../assets/images/saree-category.png";
import { toHttps } from "../utils/imageUtils";

const CategoryListPage = () => {
    const { typeName } = useParams();
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);

                // Fetch category types
                const categoryTypesResponse = await fetch(
                    `${BaseUrl}/categorytypes/allcategorytypes`
                );
                const categoryTypesData = categoryTypesResponse.ok
                    ? await categoryTypesResponse.json()
                    : [];

                // Fetch categories
                const categoryResponse = await fetch(
                    `${BaseUrl}/categories/allcategory`
                );
                const categoryData = categoryResponse.ok
                    ? await categoryResponse.json()
                    : [];

                // Fetch all products to check stock
                const productsResponse = await fetch(
                    `${BaseUrl}/products/getallproducts`
                );
                const productsData = productsResponse.ok
                    ? await productsResponse.json()
                    : [];

                if (!Array.isArray(categoryData) || !Array.isArray(productsData) || !Array.isArray(categoryTypesData)) {
                    setLoading(false);
                    return;
                }

                // Normalized name from URL (e.g. "ready-to-wear" -> "ready to wear")
                const normalizedTypeName = typeName.toLowerCase().replace(/-/g, " ");

                // Find the type ID for this normalized name
                const targetType = categoryTypesData.find(t => t.typeName.toLowerCase() === normalizedTypeName);

                // Filter categories based on the typeName from URL
                const filtered = categoryData
                    .filter((category) => {
                        if (category.isDeleted) return false;

                        // Match by Type ID or by Type Name string
                        const matchesType = (targetType && category.categoryTypeId && category.categoryTypeId.toString() === targetType._id.toString()) ||
                            (category.categoryTypeId === (targetType ? targetType._id : null)) ||
                            (category.categoryTypeName && category.categoryTypeName.toLowerCase() === normalizedTypeName) ||
                            (category.typeName && category.typeName.toLowerCase() === normalizedTypeName) ||
                            (category.categoryType && category.categoryType.toLowerCase() === normalizedTypeName);

                        if (!matchesType) return false;

                        // Optional: Check if category has products in stock
                        // Uncomment if you only want to show categories with available items
                        /*
                        const availableProductsCount = productsData.filter(
                            (product) =>
                                !product.isDeleted &&
                                product.categoryName === category.categoryName &&
                                product.stock > 0 &&
                                !product.outOfStock
                        ).length;
                        
                        return availableProductsCount > 0;
                        */
                        return true;
                    })
                    .map((category) => ({
                        name: category.categoryName,
                        image: toHttps(category.categotyImage) || (BaseUrl + category.categotyImage) || defaultImage,
                        path: category.categoryName.toLowerCase().replace(/\s+/g, "-"),
                    }));

                setCategories(filtered);
                setLoading(false);
            } catch (error) {
                console.error("Error fetching category list data:", error);
                setLoading(false);
            }
        };

        fetchData();
    }, [typeName]);

    // Format display title
    const displayTitle = typeName.split("-").map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(" ");

    return (
        <div className="sarees-page">
            <div className="sarees-hero-banner">
                <img
                    src="https://images.unsplash.com/photo-1610030469983-98e550d6193c?auto=format&fit=crop&w=1600&q=80"
                    alt={`${displayTitle} Collection Banner`}
                    onError={(e) => {
                        e.target.style.display = "none";
                    }}
                />
                <div className="sarees-hero-overlay">
                    <h1>{displayTitle}</h1>
                </div>
            </div>

            {loading && <div className="sarees-loading">Loading categories...</div>}

            {!loading && categories.length > 0 && (
                <div className="sarees-categories-section">
                    <div className="sarees-category-cards">
                        {categories.map((category, index) => (
                            <Link
                                to={`/category/${category.path}`}
                                key={index}
                                className="saree-card-link"
                            >
                                <div className="saree-card">
                                    <img
                                        src={category.image}
                                        alt={category.name}
                                        onError={(e) => {
                                            e.target.src = defaultImage;
                                        }}
                                    />
                                    <div className="saree-card-overlay">
                                        <h3>{category.name}</h3>
                                    </div>
                                </div>
                            </Link>
                        ))}
                    </div>
                </div>
            )}

            {!loading && categories.length === 0 && (
                <div className="sarees-empty">
                    No categories available in {displayTitle} at the moment. Please check back later.
                </div>
            )}
        </div>
    );
};

export default CategoryListPage;
